<template>
  <div>
    <el-popover
      ref="popover1"
      placement="top-start"
      width="200"
      trigger="hover"
      content="Le genre est peu renseigné en général dans les catalogues. Ce critère de recherche peut être décevant.">
    </el-popover>

    <div
      class="form-advanced__field"
      v-for="(item, key) in criterias"
      :key="key"
    >

      <!-- Criteria management -->
      <el-form-item class="form-advanced__more">
        <el-button
          type="primary"
          @click="() => removeCriteria(type, key)"
          v-if="key !== 0"
          :title="$t('forms.advanced.removeCriteria')"
        >-</el-button>
      </el-form-item>

      <!-- {{$t('options.exhibition[0].label')}}
      {{item.criteria}} -->

      <!-- Criteria select -->
      <el-form-item class="form-advanced__criteria">
        <el-select v-if="type === 'exhibition'" v-model="item.criteria" @change="(e) => changeCriteria(e, key)">
          <el-option
            v-for="criteria in $t('options.exhibition')"
            :label="criteria.label"
            :value="criteria"
            :key="criteria.value">
          </el-option>
        </el-select>

        <el-select v-if="type === 'exhibitor'" v-model="item.criteria" @change="(e) => changeCriteria(e, key)">
          <el-option
            v-for="criteria in $t('options.exhibitor')"
            :label="criteria.label"
            :value="criteria"
            :key="criteria.value">
          </el-option>
        </el-select>

        <el-select v-if="type === 'exhibited_work'" v-model="item.criteria" @change="(e) => changeCriteria(e, key)">
          <el-option
            v-for="criteria in $t('options.exhibited_work')"
            :label="criteria.label"
            :value="criteria"
            :key="criteria.value">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- Country inputs -->
      <el-form-item class="form-country-selector" v-if="item.criteria.type === 'country'">
        <el-select v-model="item.country" filterable>
          <el-option
            v-for="country in countriesOptionsTranslated"
            :label="country.label"
            :value="country.value"
            :key="country.id">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- exhibition group inputs -->
      <el-form-item class="form-exhib_group-selector" v-if="item.criteria.type === 'exhib_group'">
        <el-select v-model="item.exhib_group" filterable>
          <el-option
            v-for="group in exhib_groupsOptionsTranslated"
            :label="group.label"
            :value="group.value"
            :key="group.id">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- Date inputs -->
      <div class="form-advanced__date-selector" v-if="item.criteria.type === 'date'" >

        <el-form-item class="form-advanced__date-strategy">
          <el-select v-model="item.strategy">
            <el-option
              v-for="strategy in $t('options.dateStrategy')"
              :label="strategy.label"
              :value="strategy.value"
              :key="strategy.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="form-advanced__date">
          <el-input
            v-model="item.begin"
            :placeholder="$t('forms.advanced.yearPlaceholder')"
            type="number"
            :min="minYear"
            :max="maxYear"
          ></el-input>
        </el-form-item>

        <el-form-item class="form-advanced__date" label="à" v-if="item.strategy === 'bt'">
          <el-input
            v-model="item.end"
            :placeholder="$t('forms.advanced.yearPlaceholder')"
            type="number"
            :min="minYear"
            :max="maxYear"
          ></el-input>
        </el-form-item>

      </div>

      <!-- Number inputs -->
      <div class="form-advanced__number-selector"
        v-if="item.criteria.type === 'number'" >

        <el-form-item class="form-advanced__number-strategy">
          <el-select v-model="item.strategy">
            <el-option
              :label="strategy.label"
              :value="strategy.value"
              :key="strategy.value"
              v-for="strategy in $t('options.numStrategy')">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="form-advanced__number">
          <el-input
            v-model="item.begin"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item class="form-advanced__number" label="et" v-if="item.strategy === 'bt'">
          <el-input
            v-model="item.end"
            type="number"
          ></el-input>
        </el-form-item>
        <label class="el-form-item__label" v-if="item.criteria.unit">{{item.criteria.unit}}</label>

      </div>

      <!-- Text inputs -->
      <div class="form-advanced__text-selector" v-if="item.criteria.type === 'text'">
        <el-form-item class="form-advanced__text-strategy">
          <el-select v-model="item.strategy">
            <el-option
              :label="strategy.label"
              :value="strategy.value"
              :key="strategy.value"
              v-for="strategy in $t('options.textStrategy')">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="form-advanced__value">
          <div
            class="form-advanced__value-item"
            v-for="(currentValue, index) in item.value"
            v-if="item.strategy !== 'nis'"
            :key="index">
            <el-input
              class="form-advanced__value-input"
              :placeholder="$t('forms.advanced.keyword')"
              v-model="item.value[index]"
            ></el-input>
            <el-button
              class="form-advanced__value-button"
              type="primary"
              @click="() => addTextValue(item)"
              :title="$t('forms.advanced.orTitle')"
            >{{$t('forms.advanced.or')}}</el-button>
          </div>
        </el-form-item>
      </div>

      <!-- Gender inputs -->
      <el-form-item v-popover:popover1 class="form-gender-selector" v-if="item.criteria.type === 'gender'">
        <el-select v-model="item.gender">
          <el-option
            :label="strategy.label"
            :value="strategy.value"
            :key="strategy.value"
            v-for="strategy in $t('options.genderStrategy')">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- Boolean inputs -->
      <div class="form-advanced__boolean-selector" v-if="item.criteria.type === 'boolean'">
        <el-form-item class="form-advanced__boolean-strategy">
          <el-select v-model="item.strategy">
            <el-option
              :label="strategy.label"
              :value="strategy.value"
              :key="strategy.value"
              v-for="strategy in $t('options.booleanStrategy')">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>
    <el-form-item class="form-advanced__more">
      <el-button
        type="primary"
        @click="() => addCriteria(type)"
        :title="$t('forms.advanced.addCriteria')"
      >+</el-button> {{$t('forms.advanced.addCriteria')}}
    </el-form-item>
  </div>
</template>

<script>
import {
  FormItem,
  Select,
  Option,
  Button,
  Input,
  Popover
} from 'element-ui'
export default {
  name: 'form-advanced-field',
  props: [
    'type', 'criterias', 'options',
    'changeCriteria', 'addCriteria', 'removeCriteria',
    'addTextValue', 'countriesOptions', 'exhib_groupsOptions'
  ],
  data () {
    return {
      minYear: 1000,
      maxYear: new Date().getFullYear()
    }
  },
  computed: {
    countriesOptionsTranslated () {
      return this.countriesOptions.map(item => ({
        label: this.$i18n.locale === 'en_GB' ? item.nameen : item.namefr,
        value: item.namefr,
        id: item.id
      })).sort((a, b) => (a.id === 'all' ? -1 : (a.label > b.label ? 1 : (a.label < b.label ? -1 : 0))))
    },
    exhib_groupsOptionsTranslated () {
      return this.exhib_groupsOptions.map(item => ({
        label: this.$i18n.locale === 'en_GB' ? item.titleen : item.titlefr,
        value: item.titlefr,
        id: item.id
      })).sort((a, b) => (a.label > b.label ? 1 : (a.label < b.label ? -1 : 0)))
    }
  },
  components: {
    elFormItem: FormItem,
    elSelect: Select,
    elOption: Option,
    elInput: Input,
    elButton: Button,
    elPopover: Popover
  }
}
</script>

<style>
.form-advanced__field {
  display: flex;
  flex-wrap: wrap;
}

.form-advanced__criteria,
.form-advanced__date-selector,
.form-advanced__text-selector,
.form-advanced__boolean-selector,
.form-advanced__number-selector {
  flex: 1;
  display: flex;
}

.form-advanced__more {
  flex-basis: 70px;
}

.form-advanced__date,
.form-advanced__number,
.form-advanced__date-strategy,
.form-advanced__boolean-strategy {
  max-width: 10rem;
}

@media (min-width: 992px) {
  .form-advanced__criteria, .form-advanced__value, .form-advanced__date-selector {
    flex: 1;
  }
}

.form-advanced__criteria {
  flex: 15rem;
  max-width: 20rem;
}

.form-advanced__criteria .el-form-item__content,
.form-advanced__value .el-form-item__content,
.form-advanced__date-selector .el-form-item.form-advanced__date,
.form-advanced__number-selector .el-form-item.form-advanced__number {
  width: 100%;
  display: flex;
}


.form-advanced__text-selector {
  flex-grow: 2;
  display: flex;
}

.form-advanced__value {
  flex-grow: 2;
}

.form-advanced__value-item {
  display: flex;
  margin-bottom: 1rem;
}
.form-advanced__value-button {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/FormAdvanced/FormAdvancedField.vue